import React from 'react'
import {
  AccountTree,
  Dashboard,
  Inventory,
  ListAlt,
  People,
  RequestQuote,
  ShoppingCart,
  Store,
  SupportAgent
} from '@mui/icons-material'

export const CLIENT_NAVLINKS = [
  {
    title: 'Dashboard',
    to: 'dashboard',
    sub: [],
    flag: '',
    userGroups: ['owner', 'admin'],
    tooltip: <Dashboard />
  },
  {
    title: 'Shop',
    to: 'shop',
    sub: [],
    flag: 'navbar-shop',
    userGroups: ['owner', 'admin'],
    tooltip: <Store />
  },
  {
    title: 'Orders',
    to: 'orders',
    flag: 'navbar-orders',
    userGroups: ['owner', 'admin'],
    tooltip: <ShoppingCart />,
    sub: []
  },
  {
    title: 'Accounts',
    to: 'manage-accounts',
    sub: [],
    flag: 'navbar-manageAccounts',
    userGroups: ['owner'],
    tooltip: <AccountTree />
  },
  /* Code commented out because the implementation does not exist Author: @Junaid Sakib
  {
    title: 'Quotations',
    to: 'quotations',
    sub: [],
    flag: 'navbar-quotes',
    userGroups: ['owner', 'admin'],
    tooltip: <RequestQuote />
  },
  {
    title: 'Bills',
    to: 'billing',
    sub: [],
    flag: 'navbar-bills',
    userGroups: ['owner', 'admin'],
    tooltip: <ReceiptLong />
  },
  */
  {
    title: 'Support',
    to: 'customer-support',
    sub: [],
    flag: 'navbar-customerSupport',
    userGroups: ['owner', 'admin'],
    tooltip: <SupportAgent />
  }
]

export const VENDOR_NAVLINKS = [
  {
    title: 'Orders',
    to: 'manage-orders',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'ops'],
    tooltip: <ShoppingCart />
  },
  {
    title: 'Customers',
    to: 'manage-customers-orbit',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'ops'],
    tooltip: <People />
  },
  {
    title: 'Inventory',
    to: 'manage-inventory',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'ops'],
    tooltip: <Inventory />
  },
  {
    title: 'Accounts',
    to: 'manage-accounts',
    sub: [],
    flag: '',
    userGroups: ['opsowner'],
    tooltip: <AccountTree />
  },
  {
    title: 'Quotations',
    to: 'manage-quotation',
    sub: [],
    flag: 'navbar-quotes',
    userGroups: ['opsowner', 'ops'],
    tooltip: <RequestQuote />
  },
  {
    title: 'Bills',
    to: 'manage-bill',
    sub: [],
    flag: 'navbar-bills',
    userGroups: ['opsowner', 'ops'],
    tooltip: <ListAlt />
  },
  /* commenting this out as this is not yet implemented properly in orbit
  {
    title: 'Payments',
    to: 'manage-payment',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'ops'],
    tooltip: <SupportAgent />
  },
  {
    title: 'Vouchers',
    to: 'manage-vouchers-orbit',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'ops'],
    tooltip: <SupportAgent />
  },
  {
    title: 'Finance',
    to: 'finance-orbit',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'ops'],
    tooltip: <SupportAgent />
  },
  */
  {
    title: 'Support',
    to: 'customer-support',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'ops'],
    tooltip: <SupportAgent />
  }
]

export const VENDOR_NAVLINKS_JETPAC = [
  // ADD FOR EASIER TESTING, WILL REORG AGN

  {
    title: 'Orbit',
    to: '',
    sub: [
      {
        title: 'Manage Orders',
        to: 'manage-orders',
        sub: [],
        flag: '',
        userGroups: ['opsowner', 'ops'],
        tooltip: <ShoppingCart />
      },
      {
        title: 'Manage Customers',
        to: 'manage-customers-orbit',
        sub: [],
        flag: '',
        userGroups: ['opsowner', 'ops'],
        tooltip: <People />
      },
      {
        title: 'Manage Inventory',
        to: 'manage-inventory',
        sub: [],
        flag: '',
        userGroups: ['opsowner', 'ops'],
        tooltip: <Inventory />
      },
      {
        title: 'Manage Accounts',
        to: 'manage-accounts',
        sub: [],
        flag: '',
        userGroups: ['opsowner'],
        tooltip: <AccountTree />
      },
      {
        title: 'Manage Bills',
        to: 'manage-bill',
        sub: [],
        flag: '',
        userGroups: ['opsowner', 'ops'],
        tooltip: <ListAlt />
      },
      {
        title: 'Manage Quotation',
        to: 'manage-quotation',
        sub: [],
        flag: '',
        userGroups: ['opsowner', 'ops'],
        tooltip: <RequestQuote />
      },
      // HIDE AS UNUSED CURRENTLY
      // {
      //   title: 'Manage Support',
      //   to: 'customer-support',
      //   sub: [],
      //   flag: '',
      //   userGroups: ['opsowner', 'ops'],
      //   tooltip: <SupportAgent />
      // },
      // {
      //   title: 'Manage Payment',
      //   to: 'manage-payment',
      //   sub: [],
      //   flag: '',
      //   userGroups: ['opsowner', 'ops'],
      //   tooltip: <SupportAgent />
      // },
      {
        title: 'Manage Vouchers',
        to: 'manage-vouchers-orbit',
        sub: [],
        flag: '',
        userGroups: ['opsowner', 'ops'],
        tooltip: <SupportAgent />
      },
      {
        title: 'Finance',
        to: 'finance-orbit',
        sub: [],
        flag: '',
        userGroups: ['opsowner', 'ops'],
        tooltip: <SupportAgent />
      }
    ],
    flag: '',
    userGroups: ['opsowner', 'ops'],
    tooltip: <ShoppingCart />
  },

  {
    title: 'Faber',
    to: '',
    sub: [
      {
        title: 'Faber - Customers',
        to: 'manage-customers-faber',
        sub: [],
        flag: '',
        userGroups: ['opsowner', 'ops'],
        tooltip: <SupportAgent />
      },
      {
        title: 'Faber - Vouchers',
        to: 'manage-vouchers-faber',
        sub: [],
        flag: '',
        userGroups: ['opsowner', 'ops'],
        tooltip: <SupportAgent />
      },
      {
        title: 'Faber - Finance',
        to: 'finance-faber',
        sub: [],
        flag: '',
        userGroups: ['opsowner', 'ops'],
        tooltip: <SupportAgent />
      },
      {
        title: 'Faber - Status',
        to: 'status-faber',
        sub: [],
        flag: '',
        userGroups: ['opsowner'],
        tooltip: <SupportAgent />
      }
    ],
    flag: '',
    userGroups: ['opsowner', 'ops'],
    tooltip: <SupportAgent />
  }
]

// Only show Faber navlinks
export const VENDOR_NAVLINKS_OLD = [
  // ADD FOR EASIER TESTING, WILL REORG AGN

  {
    title: 'Jetpac - Subscription Customers (SG)',
    to: 'manage-customers-faber',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'opsviewer', 'ops'],
    tooltip: <SupportAgent />
  },
  {
    title: 'Jetpac - One Time Pack Customers (SG)',
    to: 'manage-otpack',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'opsviewer', 'ops'],
    tooltip: <SupportAgent />
  },
  {
    title: 'Jetpac - Global Customers',
    to: 'manage-global-cx',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'opsviewer', 'ops'],
    tooltip: <SupportAgent />
  },
  {
    title: 'Jetpac - Terminated customers',
    to: 'manage-terminated-faber',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'opsviewer', 'ops'],
    tooltip: <SupportAgent />
  },

  {
    title: 'Jetpac - Finance',
    to: 'finance-faber',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'opsviewer', 'ops'],
    tooltip: <SupportAgent />
  },

  /* HIDE FOR NOW, ACCESS VIA ROUTE IF NEEDED */
  // {
  //   title: 'Faber - Status',
  //   to: 'status-faber',
  //   sub: [],
  //   flag: '',
  //   userGroups: ['opsowner'],
  //   tooltip: <SupportAgent />
  // },
  {
    title: 'Jetpac - Inventory',
    to: 'manage-inventory/manage-inventory-faber',
    sub: [],
    flag: 'esim-inventory',
    userGroups: ['opsowner', 'opsviewer', 'ops'],
    tooltip: <Inventory />
  },
  {
    title: 'Jetpac - Catalogue',
    to: 'manage-catalogue',
    sub: [],
    flag: 'view-catalog-ch',
    userGroups: ['opsowner', 'opsviewer', 'ops'],
    tooltip: <Inventory />
  },
  {
    title: 'Jetpac - Rewards',
    to: 'manage-rewards',
    sub: [],
    flag: '',
    userGroups: ['opsowner'],
    tooltip: <Inventory />
  },

  {
    title: 'Manage Ops Accounts',
    to: 'manage-accounts',
    sub: [],
    flag: '',
    userGroups: ['opsowner'],
    tooltip: <AccountTree />
  }
]
